import axios from 'axios';

import { TaskModel } from '../models/TaskModel';

const API_URL = process.env.REACT_APP_API_URL;
export const LEAD_CONTROL_TASKS_URL = `${API_URL}/api/crm/lead-control-tasks/`;
export const LEAD_CONTROL_TASKS_PER_PAGE = 100;

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export interface ListLeadControlTasksParams {
  currentAttemptNumber?: number;
  limit?: number;
  offset?: number;
}
export function listLeadControlTasks({
  currentAttemptNumber,
  limit = 100,
  offset = 0,
}: ListLeadControlTasksParams): Promise<{
  data: PaginatedResponse<TaskModel>;
}> {
  return axios({
    method: 'get',
    url: LEAD_CONTROL_TASKS_URL,
    params: {
      current_attempt_number: currentAttemptNumber,
      limit,
      offset,
    },
  });
}

interface BulkSolveLeadControlTasksParams {
  taskResolution: number;
  tasks: Array<number>;
  owner?: number;
}
export function bulkSolveLeadControlTasks({
  taskResolution,
  tasks,
  owner,
}: BulkSolveLeadControlTasksParams): Promise<{ data: TaskModel }> {
  return axios({
    method: 'patch',
    url: `${LEAD_CONTROL_TASKS_URL}bulk-solve/`,
    data: {
      task_resolution: taskResolution,
      tasks: tasks,
      owner: owner,
    },
  });
}
